import { uploadCanvasImage, type CanvasImage } from '@/utils/canvas';
import type { IImageInput, IVideoInput } from '@/types';

type UpdateInputFn = (params: {
  id: string;
  value: Partial<IImageInput | IVideoInput>;
}) => void;

type UploadAndUpdateInputParams = {
  inputId: string;
  image: CanvasImage;
  updateInput: UpdateInputFn;
};

/**
 * Upload a canvas image and update the input with the CDN URL.
 * Handles loading state and error recovery.
 */
export const uploadAndUpdateInput = async ({
  inputId,
  image,
  updateInput,
}: UploadAndUpdateInputParams): Promise<void> => {
  updateInput({
    id: inputId,
    value: { isLoading: true } as Partial<IImageInput | IVideoInput>,
  });

  try {
    const cdnUrl = await uploadCanvasImage({
      url: image.url,
      imageId: image.id,
    });
    updateInput({
      id: inputId,
      value: { src: cdnUrl, isLoading: false } as Partial<
        IImageInput | IVideoInput
      >,
    });
  } catch {
    updateInput({
      id: inputId,
      value: { isLoading: false } as Partial<IImageInput | IVideoInput>,
    });
  }
};
